<template>
	<div class="divide-y-2 divide-gray-200">
		<ui-alert-errors
			v-if="errorMessages.length > 0"
			:messages="errorMessages"
		/>

		<tradable-terms-summary
			:offer="form"
			:commodity-future="commodityFuture"
			:reference="reference"
			:large-view="true"
			:match="match"
			:user="user"
			class="px-6 pt-4 pb-6"
		/>

		<crop-cost-warning :bid="form" :meta="meta" v-if="form.commission" />
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		reference: {
			type: Object,
			required: false,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		match: {
			type: Object,
			required: false,
			default: null,
		},
		user: {
			type: Object,
			required: false,
		},
		trade: {
			type: String,
			required: true,
		},
	},
	computed: {
		errorMessages() {
			return Object.values(this.form.errors);
		},
		commodityFuture() {
			if (this.form.price.commodity_future_id) {
				let commodityFutureId = this.form.price.commodity_future_id;
				return this.activeFutures.filter((f) => f.id == commodityFutureId)[0];
			} else {
				return null;
			}
		},
		meta() {
			return {
				trade: this.trade,
			};
		},
	},
};
</script>
